/* ==========================================================================
   Longevity Pet — Landing "Chiedi all'Esperto"
   JS unico della landing, caricato con defer dalle sezioni che lo usano.
   Nessuna libreria esterna.
   Riferimento: _esperto-docs/spec-landing-esperto.md

   1. Carosello dubbi (§ 5.2) — [data-lpe-carousel]
   2. Form (§ 8.1–8.3) — [data-lpe-form]. Invio a Klaviyo dal blocco 3b.
   3. Ancora #form — correzione a fine scroll dei CTA "Parla con Francesca".
   4. CTA sticky (§ 5.8) — [data-lpe-sticky].
   5. Eventi GA4 (§ 5.9) — [data-lpe-cta], FAQ. Inizio e invio del form
      stanno nella parte 2.
   ========================================================================== */

(function () {
  'use strict';

  var reduceMotion = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : { matches: false };

  /* ------------------------------------------------------------------------
     Tracking GA4 (spec § 5.9)
     gtag diretto, come le landing quiz e calendario (lp-calendario.js,
     track). Se gtag non c'è (cookie analitici rifiutati, blocker) l'evento
     non parte e non si rompe niente. Mai dati personali nei parametri.
     ------------------------------------------------------------------------ */

  function track(name, params) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, params || {});
      }
    } catch (e) { /* il tracking non deve mai bloccare la pagina */ }
  }

  // esperto_form_start parte una volta sola per caricamento di pagina,
  // anche dopo "Scrivi un altro messaggio".
  var formStarted = false;

  /* ------------------------------------------------------------------------
     1. Carosello dubbi
     Logica della bozza (bozza-filippo-logica.js, onScroll/goTo): il puntino
     attivo è la card il cui bordo sinistro è più vicino all'inizio dello
     scroll. In più, correzioni della spec: frecce disabilitate ai capi,
     sfumatura nascosta in fondo, niente scroll smooth con reduced-motion.

     Solo sotto 760px: da lì in su la sezione è una griglia (spec § 0) e il
     carosello non fa niente, salvo togliere il tabindex del contenitore.
     Se la finestra passa sotto 760px riparte, se torna sopra si spegne
     (matchMedia, stessa soglia del CSS).
     ------------------------------------------------------------------------ */

  var carouselMq = window.matchMedia
    ? window.matchMedia('(max-width: 759px)')
    : { matches: true };

  function initCarousel(root) {
    if (root.dataset.lpeReady) return;
    root.dataset.lpeReady = '1';

    var viewport = root.querySelector('[data-lpe-viewport]');
    var scroller = root.querySelector('[data-lpe-scroller]');
    if (!scroller) return;
    var track = scroller.firstElementChild;
    var cards = track ? Array.prototype.slice.call(track.children) : [];
    var prev = root.querySelector('[data-lpe-prev]');
    var next = root.querySelector('[data-lpe-next]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-lpe-dot]'));
    var active = 0;
    var ticking = false;

    // Posizione di scroll che porta la card all'inizio, rispettando il
    // padding sinistro del contenitore (nella bozza la prima card finiva
    // a 40px e la freccia "indietro" non tornava mai all'inizio).
    function targetLeft(card) {
      var pad = parseFloat(getComputedStyle(scroller).paddingLeft) || 0;
      return Math.max(0, card.offsetLeft - pad);
    }

    function maxScroll() {
      return scroller.scrollWidth - scroller.clientWidth;
    }

    function update() {
      ticking = false;
      if (!cards.length) return;

      var left = scroller.scrollLeft;
      var best = 0;
      var dist = Infinity;
      cards.forEach(function (card, i) {
        var d = Math.abs(targetLeft(card) - left);
        if (d < dist) { dist = d; best = i; }
      });

      var atStart = left <= 1;
      var atEnd = left >= maxScroll() - 1;
      // In fondo nessuna card arriva all'inizio: si attiva l'ultimo puntino,
      // altrimenti l'ultimo non si accenderebbe mai su desktop.
      if (atEnd && !atStart) best = cards.length - 1;
      active = best;

      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
      if (viewport) viewport.classList.toggle('is-end', atEnd);

      dots.forEach(function (dot, i) {
        if (i === active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    function goTo(i) {
      var card = cards[Math.max(0, Math.min(cards.length - 1, i))];
      if (!card) return;
      scroller.scrollTo({
        left: targetLeft(card),
        behavior: reduceMotion.matches ? 'auto' : 'smooth'
      });
    }

    // "Indietro" va alla card più a destra fra quelle che iniziano prima
    // della posizione attuale. Con goTo(active - 1) in fondo non funzionava:
    // lì active è l'ultima card, ma la penultima sta oltre maxScroll, quindi
    // lo scroll restava fermo.
    function prevIndex() {
      var left = scroller.scrollLeft;
      for (var i = cards.length - 1; i >= 0; i--) {
        if (targetLeft(cards[i]) < left - 1) return i;
      }
      return 0;
    }

    if (prev) prev.addEventListener('click', function () {
      if (carouselMq.matches) goTo(prevIndex());
    });
    if (next) next.addEventListener('click', function () {
      if (carouselMq.matches) goTo(active + 1);
    });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        if (carouselMq.matches) goTo(parseInt(dot.getAttribute('data-lpe-dot'), 10));
      });
    });

    var on = false;

    // Il contenitore è raggiungibile con Tab solo quando scorre davvero,
    // sotto 760px: lì le frecce della tastiera lo fanno scorrere. Sopra è una
    // griglia ferma e il Tab la salta. role e aria-label restano sempre.
    function sync() {
      if (carouselMq.matches) scroller.setAttribute('tabindex', '0');
      else scroller.removeAttribute('tabindex');

      if (carouselMq.matches && !on) {
        on = true;
        scroller.addEventListener('scroll', requestUpdate, { passive: true });
        window.addEventListener('resize', requestUpdate);
        update();
      } else if (!carouselMq.matches && on) {
        on = false;
        scroller.removeEventListener('scroll', requestUpdate);
        window.removeEventListener('resize', requestUpdate);
      }
    }

    // addListener: Safari prima della 14 non ha addEventListener sui media query
    if (carouselMq.addEventListener) carouselMq.addEventListener('change', sync);
    else if (carouselMq.addListener) carouselMq.addListener(sync);
    sync();
  }

  /* ------------------------------------------------------------------------
     2. Form
     Validazione della spec § 8.2: al submit, poi in tempo reale sul singolo
     campo dopo il suo primo errore. Al submit con errori il focus va sul
     primo campo sbagliato. Antispam della spec § 8.3: honeypot, time-trap
     di 3 secondi, bottone disabilitato durante l'invio.

     Blocco 3b: al submit valido l'evento "Richiesta Esperto" va alla Client
     API di Klaviyo, con i nomi della spec § 9.1 (proprietà pet_* di profilo,
     proprietà dell'evento, slug delle aree, tipo_richiesta), più l'iscrizione
     alla lista se la casella marketing è spuntata. Poi conferma in pagina o
     messaggio di errore. pet_concerns non si scrive mai dalla landing.

     I messaggi di errore sono nelle impostazioni della sezione e arrivano
     qui come data-msg-* sul <form>.
     ------------------------------------------------------------------------ */

  // Regex della bozza (bozza-filippo-logica.js, riga 73) corretta. Là era
  // scritta come in una stringa, "\\s": dentro una regex letterale vuol dire
  // "né backslash né s", quindi ogni indirizzo con una "s" veniva rifiutato.
  // Qui \s è lo spazio. Per il resto identica: qualcosa, @, qualcosa, punto,
  // almeno due lettere.
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i;
  var DESC_MIN = 15;         // bozza: description.trim().length < 15
  var TIME_TRAP_MS = 3000;   // spec § 8.3
  var ORIGINE = 'landing-chiedi-all-esperto';
  var METRICA = 'Richiesta Esperto';

  function initForm(form) {
    if (form.dataset.lpeReady) return;
    form.dataset.lpeReady = '1';

    var loadedAt = Date.now();
    var busy = false;

    function q(sel) { return form.querySelector(sel); }
    function qa(sel) { return Array.prototype.slice.call(form.querySelectorAll(sel)); }
    function msg(key) { return form.getAttribute('data-msg-' + key) || ''; }
    function checkedValues(name) {
      return qa('input[name="' + name + '"]:checked').map(function (i) { return i.value; });
    }

    var speciesInputs = qa('input[name="pet_species"]');
    var chipInputs = qa('input[name="aree"], input[name="tipo_richiesta"]');
    var petName = q('[name="pet_name"]');
    var age = q('[name="pet_age_label"]');
    var weight = q('[data-lpe-weight]');
    var desc = q('[name="descrizione"]');
    var name = q('[name="first_name"]');
    var email = q('[name="email"]');
    var privacy = q('[name="privacy"]');
    var marketing = q('[name="consenso_marketing"]');
    var hp = q('[data-lpe-hp]');
    var submit = q('[data-lpe-submit]');

    var bands = {};
    try { bands = JSON.parse(q('[data-lpe-bands]').textContent); } catch (e) { bands = {}; }

    // Fasce di peso della specie scelta. Cambiando specie la fascia si
    // azzera: le fasce di cane e gatto sono diverse.
    function fillWeight() {
      if (!weight) return;
      var species = checkedValues('pet_species')[0] || '';
      var list = bands[species] || [];
      weight.innerHTML = '';
      var empty = document.createElement('option');
      empty.value = '';
      empty.textContent = weight.getAttribute(species ? 'data-placeholder' : 'data-placeholder-no-species') || '';
      weight.appendChild(empty);
      list.forEach(function (band) {
        var opt = document.createElement('option');
        opt.value = band.value;
        opt.textContent = band.label;
        weight.appendChild(opt);
      });
      weight.disabled = !species;
    }

    // Un campo = cosa si controlla, quali input marcare, dove scrivere l'errore.
    var fields = [
      { key: 'species', inputs: speciesInputs,
        check: function () { return checkedValues('pet_species').length ? '' : msg('species'); } },
      { key: 'age', inputs: [age],
        check: function () { return age.value.trim() ? '' : msg('age'); } },
      // Almeno una chip, Dosaggio e Altro compresi, come nella bozza
      { key: 'areas', inputs: chipInputs,
        check: function () { return chipInputs.some(function (i) { return i.checked; }) ? '' : msg('areas'); } },
      { key: 'desc', inputs: [desc],
        check: function () { return desc.value.trim().length >= DESC_MIN ? '' : msg('desc'); } },
      { key: 'name', inputs: [name],
        check: function () { return name.value.trim() ? '' : msg('name'); } },
      { key: 'email', inputs: [email],
        check: function () { return EMAIL_RE.test(email.value.trim()) ? '' : msg('email'); } },
      // Privacy obbligatoria e bloccante (spec § 9.4)
      { key: 'privacy', inputs: [privacy],
        check: function () { return privacy.checked ? '' : msg('privacy'); } }
    ];

    fields.forEach(function (f) {
      f.box = q('[data-lpe-field="' + f.key + '"]');
      f.errorEl = q('[data-lpe-error="' + f.key + '"]');
      f.touched = false; // true dopo il primo errore mostrato: da lì si valida in tempo reale
    });

    function showError(f, text) {
      if (f.box) f.box.classList.toggle('is-invalid', !!text);
      f.inputs.forEach(function (i) {
        if (text) i.setAttribute('aria-invalid', 'true');
        else i.removeAttribute('aria-invalid');
      });
      if (!f.errorEl) return;
      var help = f.errorEl.getAttribute('data-lpe-help');
      if (help !== null) {
        // Textarea: come nella bozza, l'errore prende il posto della nota
        f.errorEl.textContent = text || help;
        f.errorEl.classList.toggle('is-error', !!text);
      } else {
        f.errorEl.textContent = text;
        f.errorEl.hidden = !text;
      }
    }

    function validate(f) {
      var text = f.check();
      showError(f, text);
      if (text) f.touched = true;
      return !text;
    }

    fields.forEach(function (f) {
      f.inputs.forEach(function (i) {
        var live = function () { if (f.touched) validate(f); };
        i.addEventListener('input', live);
        i.addEventListener('change', live);
      });
    });

    speciesInputs.forEach(function (i) { i.addEventListener('change', fillWeight); });
    // Il browser può ripristinare la specie (torna indietro, completamento
    // automatico): il select si allinea subito.
    fillWeight();

    function focusField(f) {
      var target = f.inputs.filter(function (i) { return i.checked; })[0] || f.inputs[0];
      if (!target) return;
      try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
      var visible = (f.key === 'species' || f.key === 'areas') && f.box ? f.box : target;
      visible.scrollIntoView({ block: 'center', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }

    function setBusy(on) {
      busy = on;
      if (!submit) return;
      submit.disabled = on;
      submit.textContent = submit.getAttribute(on ? 'data-busy-label' : 'data-label') || submit.textContent;
    }

    // Nomi della spec § 9.1 e della skill verifica-esperto § 7.
    function buildPayload() {
      var profilo = {
        $email: email.value.trim(),
        $first_name: name.value.trim(),
        pet_species: checkedValues('pet_species')[0],
        pet_age_label: age.value.trim()
      };
      if (petName && petName.value.trim()) profilo.pet_name = petName.value.trim();
      // Solo la fascia, mai i kg. Se non è scelta non si manda: altrimenti
      // cancellerebbe quella dichiarata nel quiz (spec § 0, decisione 26).
      if (weight && weight.value) profilo.pet_weight_band = weight.value;

      // tipo_richiesta è un valore solo (spec § 9.1: dosaggio | altro | vuoto).
      // Con Dosaggio e Altro insieme vince dosaggio (spec § 0, decisione 25).
      var tipi = checkedValues('tipo_richiesta');
      var tipo = tipi.indexOf('dosaggio') !== -1 ? 'dosaggio' : (tipi[0] || '');

      return {
        metrica: METRICA,
        profilo: profilo,
        evento: {
          aree: checkedValues('aree'),
          tipo_richiesta: tipo,
          descrizione: desc.value.trim(),
          consenso_marketing: !!(marketing && marketing.checked),
          origine: ORIGINE
        }
      };
    }

    /* ---- 3b: invio, conferma, errore (spec § 8.3) ---- */

    var root = form.closest('.lpe-form__inner') || form.parentNode;
    var success = root.querySelector('[data-lpe-success]');
    var successTitle = success && success.querySelector('[data-lpe-success-title]');
    var sentEmail = success && success.querySelector('[data-lpe-sent-email]');
    var resetBtn = success && success.querySelector('[data-lpe-reset]');
    var sendError = q('[data-lpe-send-error]');
    var company = form.getAttribute('data-klaviyo-key') || '';
    var listId = form.getAttribute('data-klaviyo-list') || '';

    function scrollBehavior() { return reduceMotion.matches ? 'auto' : 'smooth'; }

    function setSendError(text) {
      if (sendError) sendError.textContent = text;
    }

    // Conferma al posto del form. L'email è testo scritto dall'utente:
    // textContent, mai innerHTML. Il focus va sul titolo (tabindex="-1").
    function showSuccess(address) {
      if (sentEmail) sentEmail.textContent = address;
      form.hidden = true;
      stopSticky(); // spec § 0 n. 53: dopo la conferma la barra non torna più
      if (!success) return;
      success.hidden = false;
      if (successTitle) {
        try { successTitle.focus({ preventScroll: true }); } catch (e) { successTitle.focus(); }
        successTitle.scrollIntoView({ block: 'center', behavior: scrollBehavior() });
      }
    }

    // Honeypot e time-trap: stessa conferma, nessuna chiamata (spec § 0, n. 28)
    function fakeSuccess() { showSuccess(email.value.trim()); }

    // "Scrivi un altro messaggio": form vuoto, errori e "già toccato" azzerati,
    // time-trap che riparte, focus sul primo campo.
    function resetForm() {
      form.reset();
      fillWeight();
      fields.forEach(function (f) { showError(f, ''); f.touched = false; });
      setSendError('');
      loadedAt = Date.now();
      if (success) success.hidden = true;
      form.hidden = false;
      var first = speciesInputs[0];
      if (first) {
        try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
      }
      form.scrollIntoView({ block: 'start', behavior: scrollBehavior() });
    }

    if (resetBtn) resetBtn.addEventListener('click', resetForm);

    // esperto_form_start: primo focus o input su un campo vero del form
    // (non il bottone, non l'honeypot). Nessun parametro.
    function onFormStart(e) {
      if (formStarted) return;
      var t = e.target;
      if (!t || !/^(INPUT|SELECT|TEXTAREA)$/.test(t.tagName) || t === hp) return;
      formStarted = true;
      form.removeEventListener('focusin', onFormStart);
      form.removeEventListener('input', onFormStart);
      track('esperto_form_start');
    }
    if (!formStarted) {
      form.addEventListener('focusin', onFormStart);
      form.addEventListener('input', onFormStart);
    }

    // Client API di Klaviyo: stessi endpoint, formato JSON:API e revision del
    // quiz (lp-quiz-engine.js, sendToKlaviyo). Niente klaviyo.push/_learnq:
    // l'evento arriverebbe doppio. Successo = risposta 2xx (Klaviyo dà 202);
    // uno status diverso o un errore di rete sono un fallimento.
    var REVISION = '2024-10-15';

    function klaviyoPost(path, body) {
      if (!company) return Promise.reject(new Error('chiave pubblica Klaviyo mancante'));
      return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': REVISION },
        body: JSON.stringify(body)
      }).then(function (res) {
        if (!res.ok) throw new Error('Klaviyo ' + path + ': HTTP ' + res.status);
        return res;
      });
    }

    // Evento "Richiesta Esperto": proprietà dell'evento del payload; profilo con
    // email, first_name e le sole pet_* del payload (spec § 9.1).
    function eventBody(payload) {
      var p = payload.profilo;
      var petProps = {};
      Object.keys(p).forEach(function (k) { if (k.charAt(0) !== '$') petProps[k] = p[k]; });
      return {
        data: {
          type: 'event',
          attributes: {
            properties: payload.evento,
            metric: { data: { type: 'metric', attributes: { name: payload.metrica } } },
            profile: { data: { type: 'profile', attributes: { email: p.$email, first_name: p.$first_name, properties: petProps } } }
          }
        }
      };
    }

    // Iscrizione alla lista Email Subscribers (spec § 8.3), solo l'email:
    // le pet_* le ha già scritte l'evento.
    function subscriptionBody(address) {
      return {
        data: {
          type: 'subscription',
          attributes: { profile: { data: { type: 'profile', attributes: { email: address } } } },
          relationships: { list: { data: { type: 'list', id: listId } } }
        }
      };
    }

    // Prima l'evento; l'iscrizione solo se la casella marketing è spuntata e
    // l'evento è arrivato. Se fallisce solo l'iscrizione il messaggio a
    // Francesca c'è: conferma comunque, con un avviso in console (spec § 0,
    // decisione 31).
    function sendPayload(payload) {
      return klaviyoPost('events', eventBody(payload)).then(function () {
        if (!payload.evento.consenso_marketing) return;
        return klaviyoPost('subscriptions', subscriptionBody(payload.profilo.$email)).then(null, function (err) {
          if (window.console) console.warn('[lpe-form] Iscrizione alla lista non riuscita, il messaggio è arrivato:', err);
        });
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;
      setSendError('');

      // Honeypot compilato: si finge il successo, niente altro
      if (hp && hp.value) { fakeSuccess(); return; }

      var firstBad = null;
      fields.forEach(function (f) {
        if (!validate(f) && !firstBad) firstBad = f;
      });
      if (firstBad) { focusField(firstBad); return; }

      // Time-trap: un invio entro 3 secondi dal caricamento è di un bot
      if (Date.now() - loadedAt < TIME_TRAP_MS) { fakeSuccess(); return; }

      setBusy(true);
      var payload = buildPayload();
      sendPayload(payload).then(function () {
        setBusy(false);
        showSuccess(payload.profilo.$email);
        // Solo qui, a invio riuscito: showSuccess è anche la finta conferma di
        // honeypot e time-trap, e lì l'evento non deve partire.
        track('esperto_form_submit');
      }, function (err) {
        // Niente conferma: i dati restano, il bottone torna attivo
        setBusy(false);
        setSendError(msg('send'));
        // Il bottone disabilitato ha perso il focus: lo si riporta lì per riprovare
        if (!document.activeElement || document.activeElement === document.body) submit.focus();
        if (window.console) console.warn('[lpe-form] Invio non riuscito:', err);
      });
    });
  }

  /* ------------------------------------------------------------------------
     3. Ancora #form (spec § 0 n. 37)
     I CTA "Parla con Francesca" portano a #form con lo scroll normale del
     browser (con prefers-reduced-motion è istantaneo, regola in
     lp-esperto.css). Su iPhone, al primo tap a pagina appena caricata, il
     titolo poteva finire sopra lo schermo: qualcosa sopra il form cambia
     altezza durante lo scroll. A fine scroll qui si rimisura il titolo e, se
     è a più di 4px dai 24px previsti, lo si corregge con uno scroll
     istantaneo. Se la correzione scorre verso l'alto compare l'header sticky
     del tema (.sticky-header.show): il titolo si ferma 24px sotto di lui.
     Al massimo 2 correzioni. Hash e focus restano quelli del browser.
     ------------------------------------------------------------------------ */

  var ANCHOR_GAP = 24;
  var ANCHOR_TOLERANCE = 4;
  var ANCHOR_MAX_FIXES = 2;

  function stickyHeader() { return document.querySelector('.sticky-header'); }

  // Bordo inferiore dell'header sticky se è visibile, altrimenti 0
  function stickyBottom() {
    var s = stickyHeader();
    if (!s || !s.classList.contains('show')) return 0;
    var r = s.getBoundingClientRect();
    return r.bottom > 0 ? r.bottom : 0;
  }

  // Scroll istantaneo anche con lo scroll-behavior: smooth del tema
  function jumpBy(dy) {
    var html = document.documentElement;
    var prev = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, (window.pageYOffset || html.scrollTop) + dy);
    html.style.scrollBehavior = prev;
  }

  // Chiama cb solo quando lo scroll è fermo: due letture a 120ms uguali.
  // Evita di correggere a metà di uno scroll animato lento (poi lo scroll
  // nativo andrebbe avanti e porterebbe il titolo fuori posto).
  function whenStill(cb, tries) {
    var y = window.pageYOffset;
    setTimeout(function () {
      if (Math.abs(window.pageYOffset - y) < 1) cb();
      else if ((tries || 0) < 25) whenStill(cb, (tries || 0) + 1);
    }, 120);
  }

  // Chiama cb a fine scroll, e solo a scroll fermo (whenStill):
  // - dove c'è l'evento scrollend (Chrome, Firefox) conta solo quello;
  // - altrimenti (Safari) 150ms senza eventi di scroll;
  // - se lo scroll non parte entro 1s (titolo già al suo posto) si controlla
  //   lo stesso.
  // Se dopo 8s la fine non è arrivata, si controlla lo stesso, sempre a
  // scroll fermo (una scadenza più corta correggeva a metà degli scroll
  // animati lenti, e lo scroll nativo poi andava oltre).
  function afterScroll(cb) {
    var done = false;
    var hasScrollEnd = 'onscrollend' in window;
    var idle = null;
    var noScroll = setTimeout(finish, 1000);
    var guard = setTimeout(finish, 8000);
    function onScroll() {
      clearTimeout(noScroll);
      if (!hasScrollEnd) { clearTimeout(idle); idle = setTimeout(finish, 150); }
    }
    function stop() {
      done = true;
      clearTimeout(idle); clearTimeout(noScroll); clearTimeout(guard);
      window.removeEventListener('scroll', onScroll);
      if (hasScrollEnd) window.removeEventListener('scrollend', finish);
    }
    function finish() {
      if (done) return;
      stop();
      whenStill(cb);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    if (hasScrollEnd) window.addEventListener('scrollend', finish);
  }

  // Porta il titolo a 24px dal bordo, o 24px sotto l'header sticky se è
  // visibile. Primo passo senza anticipare l'header (può non comparire);
  // se dopo uno scroll verso l'alto l'header compare e copre il titolo, il
  // secondo passo scende ancora verso l'alto, così l'header resta visibile.
  function fixAnchor(title, fixes) {
    if (fixes >= ANCHOR_MAX_FIXES) return;
    var diff = title.getBoundingClientRect().top - (ANCHOR_GAP + stickyBottom());
    if (Math.abs(diff) <= ANCHOR_TOLERANCE) return;
    jumpBy(diff);
    // Il tema mostra o nasconde l'header sull'evento di scroll, con una
    // transizione di 200ms: si rimisura dopo, a scroll fermo.
    setTimeout(function () { whenStill(function () { fixAnchor(title, fixes + 1); }); }, 250);
  }

  function initFormAnchor() {
    if (document.documentElement.hasAttribute('data-lpe-anchor')) return;
    document.documentElement.setAttribute('data-lpe-anchor', '');
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href="#form"]') : null;
      if (!a || !a.closest('.lpe')) return;
      var head = document.getElementById('form');
      if (!head) return;
      var title = head.querySelector('.lpe-form__title') || head;
      afterScroll(function () { fixAnchor(title, 0); });
    });
  }

  /* ------------------------------------------------------------------------
     4. CTA sticky (spec § 5.8, piano 5.1)
     Pattern di lp-quiz-landing.js: IntersectionObserver. La barra compare
     quando l'hero è uscito dal viewport e si nasconde quando il form è a
     schermo, anche solo in parte. Senza hero o senza form resta nascosta.
     ------------------------------------------------------------------------ */

  // Dopo un invio riuscito (showSuccess) la barra non ricompare più, fino al
  // ricaricamento della pagina (spec § 0 n. 53).
  var stickyDone = false;

  function stopSticky() {
    stickyDone = true;
    var bars = document.querySelectorAll('.lpe-sticky');
    Array.prototype.forEach.call(bars, function (bar) { bar.classList.remove('is-visible'); });
  }

  function reserveStickySpace(inner) {
    // Spazio riservato sempre, anche a barra nascosta: il fondo della pagina
    // non salta quando la barra compare (body:has(.lpe-sticky) nel CSS).
    document.documentElement.style.setProperty('--lpe-sticky-h', inner.offsetHeight + 'px');
  }

  function initSticky(inner) {
    if (inner.dataset.lpeReady) return;
    inner.dataset.lpeReady = '1';

    var bar = inner.closest('.lpe-sticky');
    var hero = document.querySelector('.lpe-hero');
    var form = document.querySelector('.lpe-form');
    if (!bar || !hero || !form) return;

    reserveStickySpace(inner);
    window.addEventListener('resize', function () { reserveStickySpace(inner); });

    if (!('IntersectionObserver' in window)) {
      // Browser senza IntersectionObserver: la barra resta visibile.
      if (!stickyDone) bar.classList.add('is-visible');
      return;
    }

    var heroIn = true;
    var formIn = false;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target === hero) heroIn = entry.isIntersecting;
        if (entry.target === form) formIn = entry.isIntersecting;
      });
      bar.classList.toggle('is-visible', !stickyDone && !heroIn && !formIn);
    }, { threshold: 0 });

    observer.observe(hero);
    observer.observe(form);
  }

  /* ------------------------------------------------------------------------
     5. Eventi GA4 dei CTA e delle FAQ (spec § 5.9)
     esperto_cta_click: un ascoltatore solo sul documento, posizione letta da
     data-lpe-cta (hero, steps, chi_risponde, sticky, conferma).
     esperto_faq_open: evento toggle dei <details>, solo all'apertura;
     domanda = testo del <summary> (l'icona è un SVG senza testo).
     data-lpe-faq-index resta nel markup ma non si invia.
     ------------------------------------------------------------------------ */

  function initCtaTracking() {
    if (document.documentElement.hasAttribute('data-lpe-cta-tracking')) return;
    document.documentElement.setAttribute('data-lpe-cta-tracking', '');
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('[data-lpe-cta]') : null;
      if (!a) return;
      track('esperto_cta_click', { posizione: a.getAttribute('data-lpe-cta') });
    });
  }

  function initFaq(item) {
    if (item.dataset.lpeReady) return;
    item.dataset.lpeReady = '1';
    item.addEventListener('toggle', function () {
      if (!item.open) return;
      var q = item.querySelector('summary');
      track('esperto_faq_open', { domanda: q ? q.textContent.trim() : '' });
    });
  }

  /* ------------------------------------------------------------------------
     Avvio, anche quando l'editor Shopify ricarica una sezione
     ------------------------------------------------------------------------ */

  function initAll(context) {
    var list = (context || document).querySelectorAll('[data-lpe-carousel]');
    Array.prototype.forEach.call(list, initCarousel);
    var forms = (context || document).querySelectorAll('[data-lpe-form]');
    Array.prototype.forEach.call(forms, initForm);
    var stickies = (context || document).querySelectorAll('[data-lpe-sticky]');
    Array.prototype.forEach.call(stickies, initSticky);
    var faqs = (context || document).querySelectorAll('.lpe-faq__item');
    Array.prototype.forEach.call(faqs, initFaq);
    initFormAnchor();
    initCtaTracking();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
